import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTimesCircle } from "@fortawesome/free-solid-svg-icons";

import { Textarea, Select } from "../../../../form-inputs/inputs";
import { Typeahead } from "../../../../form-inputs/typeahead";

const DEFAULT_FOOTNOTE = {
    noteMark: {},
    text: "",
};

class Footnotes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTemplate: "",
        };
    }

    addFootnote = (e) => {
        e.preventDefault();
        this.props.updateOnChange("footnotes", [...this.props.data.items, { ...DEFAULT_FOOTNOTE }]);
    };

    removeFootnote = (index) => {
        const newFootnotes = [...this.props.data.items];
        newFootnotes.splice(index, 1);
        this.props.updateOnChange("footnotes", newFootnotes);
        document.getElementsByName("newFootnote")[0].focus();
    };

    updateFootnoteMark = (name, value, index) => {
        const newFootnotes = [...this.props.data.items];
        newFootnotes[index] = { ...newFootnotes[index], noteMark: value };
        this.props.updateOnChange("footnotes", newFootnotes);
        document.getElementsByName(name)[0].focus();
    };

    updateFootnoteText = (name, value, index) => {
        const newFootnotes = [...this.props.data.items];
        newFootnotes[index] = { ...newFootnotes[index], text: value };
        this.props.updateOnChange("footnotes", newFootnotes);
    };

    onSelect = (name, value) => {
        this.setState({
            selectedTemplate: value,
        });

        if (value) {
            this.props.updateOnChange("footnotes", [
                ...this.props.data.items,
                {
                    noteMark: {},
                    text: value,
                },
            ]);
        }

        this.setState({
            selectedTemplate: "",
        });
    };

    render() {
        const presetSelect = this.props.presets ? (
            <Select name="footerTemplate" value={this.state.selectedTemplate} updateOnChange={this.onSelect} options={this.props.presets} />
        ) : null;
        const footnotes = this.props.data.items.map((footnote, index) => {
            return (
                <div key={`${index}_${this.props.data.length}`} className="footnote">
                    <div
                        className="close"
                        onClick={() => {
                            this.removeFootnote(index);
                        }}
                    >
                        <FontAwesomeIcon icon={faTimesCircle} />
                    </div>
                    <div className="input-group">
                        <Typeahead
                            name={`m${index}`}
                            defaultValue={footnote.noteMark}
                            options={this.props.noteMarkList}
                            updateOnChange={(name, value) => {
                                this.updateFootnoteMark(name, value, index);
                            }}
                            className="-x-small"
                        />
                        <Textarea
                            name={`f${index}`}
                            value={footnote.text}
                            updateOnChange={(name, value) => {
                                this.updateFootnoteText(name, value, index);
                            }}
                        />
                    </div>
                </div>
            );
        });

        return (
            <div className="footnotes">
                <strong>Footnotes</strong>
                <br />
                {presetSelect}
                {footnotes}
                <button name="newFootnote" className="button -primary -small" onClick={this.addFootnote}>
                    <FontAwesomeIcon icon={faPlus} /> Footnote
                </button>
            </div>
        );
    }
}

export default Footnotes;
